'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var RESULTS_LAYOUT = exports.RESULTS_LAYOUT = 'web_search_page';

var FILTER_NAMES = exports.FILTER_NAMES = {
  DATE: 'date',
  TIME: 'time',
  ACTIVITY: 'activity',
  VERTICAL: 'verticals',
  RESULT_TYPE: 'result_type'
};

var RESULT_TYPES = exports.RESULT_TYPES = {
  VENUE: 'VENUE',
  SCHEDULE: 'SCHEDULE'
};

var MAPPED_AREA = exports.MAPPED_AREA = 'Mapped area';

var SEARCH_ACCESS_PERMISSION = exports.SEARCH_ACCESS_PERMISSION = 'feature_unified_search_web';